import { createStructuredSelector } from 'reselect'

import {
  ASSESSMENT_PROJECT_LIST,
  ASSESSMENT_PROJECT_LIST_SUCCESS, 
  ASSESSMENT_PROJECT_LIST_ERROR,
  ASSESSMENT_PROJECT_PAGE_SET,
  ASSESSMENT_PROJECT_SEARCH_SET,
  ASSESSMENT_PROJECT_SEARCH_CHANGE,
  ASSESSMENT_PROJECT_SEARCH_ASSESSMENT,
  ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_SUCCESS,
  ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_ERROR, 
  ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE,
  ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE_SUCCESS,
  ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE_ERROR, 
  ASSESSMENT_PROJECT_SEARCH_DESTINATION,
  ASSESSMENT_PROJECT_SEARCH_DESTINATION_SUCCESS,
  ASSESSMENT_PROJECT_SEARCH_DESTINATION_ERROR, 
  ASSESSMENT_PROJECT_SEARCH_CONTRACT,
  ASSESSMENT_PROJECT_SEARCH_CONTRACT_SUCCESS,
  ASSESSMENT_PROJECT_SEARCH_CONTRACT_ERROR, 
  ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE,
  ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE_SUCCESS,
  ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE_ERROR, 
  ASSESSMENT_PROJECT_ADD_SET,
  ASSESSMENT_PROJECT_ADD_MODAL_SET,
  ASSESSMENT_PROJECT_ADD,
  ASSESSMENT_PROJECT_ADD_SUCCESS,
  ASSESSMENT_PROJECT_ADD_ERROR,
  ASSESSMENT_PROJECT_ADD_CHANGE,
  ASSESSMENT_PROJECT_DETAIL,
  ASSESSMENT_PROJECT_DETAIL_SUCCESS,
  ASSESSMENT_PROJECT_DETAIL_ERROR,
  ASSESSMENT_PROJECT_VIEW_MODAL_SET,
  ASSESSMENT_PROJECT_EDIT_CHANGE,
  ASSESSMENT_PROJECT_EDIT_MODAL_SET,
  ASSESSMENT_PROJECT_UPDATE,
  ASSESSMENT_PROJECT_UPDATE_SUCCESS,
  ASSESSMENT_PROJECT_UPDATE_ERROR,
  ASSESSMENT_PROJECT_VIEW_TAB_SET
} from '../../actions';

export const NAME = 'assessment_project';

export const AssessmentProjectList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: ASSESSMENT_PROJECT_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const AssessmentProjectListSuccess = (data) => ({
  type: ASSESSMENT_PROJECT_LIST_SUCCESS,
  payload: data
});

export const AssessmentProjectListError = (error) => ({
  type: ASSESSMENT_PROJECT_LIST_ERROR,
  payload: error
});

export const AssessmentProjectPageSet = (data) => ({
  type: ASSESSMENT_PROJECT_PAGE_SET,
  payload: data
});

export const AssessmentProjectSearchSet = (data) => ({
  type: ASSESSMENT_PROJECT_SEARCH_SET,
  payload: data
});

export const AssessmentProjectSearchChangeSet = (data) => ({
  type: ASSESSMENT_PROJECT_SEARCH_CHANGE,
  payload: data
});

export const AssessmentProjectSearchAssessment = (data) => ({
  type: ASSESSMENT_PROJECT_SEARCH_ASSESSMENT,
  payload: data
});

export const AssessmentProjectSearchAssessmentSuccess = (message) => ({
  type: ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_SUCCESS,
  payload: message
});

export const AssessmentProjectSearchAssessmentError = (error) => ({
  type: ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_ERROR,
  payload: error
}); 

export const AssessmentProjectSearchAssessmentType = (data) => ({
  type: ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE,
  payload: data
});

export const AssessmentProjectSearchAssessmentTypeSuccess = (message) => ({
  type: ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE_SUCCESS,
  payload: message
});

export const AssessmentProjectSearchAssessmentTypeError = (error) => ({
  type: ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE_ERROR,
  payload: error
}); 
export const AssessmentProjectSearchDestination = (data) => ({
  type: ASSESSMENT_PROJECT_SEARCH_DESTINATION,
  payload: data
});

export const AssessmentProjectSearchDestinationSuccess = (message) => ({
  type: ASSESSMENT_PROJECT_SEARCH_DESTINATION_SUCCESS,
  payload: message
});

export const AssessmentProjectSearchDestinationError = (error) => ({
  type: ASSESSMENT_PROJECT_SEARCH_DESTINATION_ERROR,
  payload: error
}); 

export const AssessmentProjectSearchContract = (data) => ({
  type: ASSESSMENT_PROJECT_SEARCH_CONTRACT,
  payload: data
});

export const AssessmentProjectSearchContractSuccess = (message) => ({
  type: ASSESSMENT_PROJECT_SEARCH_CONTRACT_SUCCESS,
  payload: message
});

export const AssessmentProjectSearchContractError = (error) => ({
  type: ASSESSMENT_PROJECT_SEARCH_CONTRACT_ERROR,
  payload: error
}); 

export const AssessmentProjectSearchEvaluationState = (data) => ({
  type: ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE,
  payload: data
}); 

export const AssessmentProjectSearchEvaluationStateSuccess = (message) => ({
  type: ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE_SUCCESS,
  payload: message
});

export const AssessmentProjectSearchEvaluationStateError = (error) => ({
  type: ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE_ERROR,
  payload: error
}); 

export const AssessmentProjectAddChangeSet = (data) => ({
  type: ASSESSMENT_PROJECT_ADD_CHANGE,
  payload: data
});

export const AssessmentProjectAddSet = (data) => ({
  type: ASSESSMENT_PROJECT_ADD_SET,
  payload: data
});

export const AssessmentProjectAddModalSet = (data) => ({
  type: ASSESSMENT_PROJECT_ADD_MODAL_SET,
  payload: data
});

export const AssessmentProjectAdd = (data) => ({
  type: ASSESSMENT_PROJECT_ADD,
  payload: data
});

export const AssessmentProjectAddSuccess = (message) => ({
  type: ASSESSMENT_PROJECT_ADD_SUCCESS,
  payload: message
});

export const AssessmentProjectAddError = (error) => ({
  type: ASSESSMENT_PROJECT_ADD_ERROR,
  payload: error
});

export const AssessmentProjectDetail = (data) => ({
  type: ASSESSMENT_PROJECT_DETAIL,
  payload: data
});

export const AssessmentProjectDetailSuccess = (data) => ({
  type: ASSESSMENT_PROJECT_DETAIL_SUCCESS,
  payload: data
});

export const AssessmentProjectDetailError = (error) => ({
  type: ASSESSMENT_PROJECT_DETAIL_ERROR,
  payload: error
});

export const AssessmentProjectViewModalSet = (data) => ({
  type: ASSESSMENT_PROJECT_VIEW_MODAL_SET,
  payload: data
});

export const AssessmentProjectEditModalSet = (data) => ({
  type: ASSESSMENT_PROJECT_EDIT_MODAL_SET,
  payload: data
});

export const AssessmentProjectEditChangeSet = (data) => ({
  type: ASSESSMENT_PROJECT_EDIT_CHANGE,
  payload: data
});

export const AssessmentProjectUpdate = (data) => ({
  type: ASSESSMENT_PROJECT_UPDATE,
  payload: data
});

export const AssessmentProjectUpdateSuccess = (message) => ({
  type: ASSESSMENT_PROJECT_UPDATE_SUCCESS,
  payload: message.message
});

export const AssessmentProjectUpdateError = (error) => ({
  type: ASSESSMENT_PROJECT_UPDATE_ERROR,
  payload: error
});

export const AssessmentProjectViewTabSet = (data) => ({
  type: ASSESSMENT_PROJECT_VIEW_TAB_SET,
  payload: data
});

const assessment_project = (state) => state[NAME];

export const AssessmentProjectSelector = createStructuredSelector({
  assessment_project
})
 